import { Injectable } from '@angular/core';
import { AddSqaErrorMessages, ErrorOption } from '@com-delta-idp/mnx-login-ui';
import { ADD_SQA_ERROR } from '../../constants/add-sqa-constants';

@Injectable({
  providedIn: 'root'
})
export class AddSqaErrorMessageHelperService {
  initialErrorMessage(
    option: ErrorOption,
    errorMessages: AddSqaErrorMessages
  ): void {
    if (option['errorId'] === ADD_SQA_ERROR.INVALID_FIRST_SEC_ANS) {
      errorMessages.answerOneErrorMessage.INVALID_FIRST_SEC_ANS =
        option['errorMessageDescription'];
    } else if (option['errorId'] === ADD_SQA_ERROR.INVALID_SECOND_SEC_ANS) {
      errorMessages.answerTwoErrorMessage.INVALID_SECOND_SEC_ANS =
        option['errorMessageDescription'];
    } else if (option['errorId'] === ADD_SQA_ERROR.SEL_FIRST_SEC_QUESTION) {
      errorMessages.questionOneErrorMessage.SEL_FIRST_SEC_QUESTION =
        option['errorMessageDescription'];
    }
    this.initialErrorMessageHelper(option, errorMessages);
  }

  initialErrorMessageHelper(
    option: ErrorOption,
    errorMessages: AddSqaErrorMessages
  ): void {
    if (option['errorId'] === ADD_SQA_ERROR.SEL_SECOND_SEC_QUESTION) {
      errorMessages.questionTwoErrorMessage.SEL_SECOND_SEC_QUESTION =
        option['errorMessageDescription'];
    } else if (option['errorId'] === ADD_SQA_ERROR.ANS_IN_USE) {
      errorMessages.answerOneErrorMessage.ANS_IN_USE =
        errorMessages.answerTwoErrorMessage.ANS_IN_USE =
          option['errorMessageDescription'];
    } else if (
      option['errorId'] === ADD_SQA_ERROR.SEC_ANS_LESS_THAN_FOUR_CHAR
    ) {
      errorMessages.answerOneErrorMessage.SEC_ANS_LESS_THAN_FOUR_CHAR =
        errorMessages.answerTwoErrorMessage.SEC_ANS_LESS_THAN_FOUR_CHAR =
          option['errorMessageDescription'];
    }
    this.initialErrorMessageSubHelper(option, errorMessages);
  }

  initialErrorMessageSubHelper(
    option: ErrorOption,
    errorMessages: AddSqaErrorMessages
  ): void {
    if (option['errorId'] === ADD_SQA_ERROR.QUESTION_IN_USE) {
      errorMessages.questionTwoErrorMessage.QUESTION_IN_USE =
        option['errorMessageDescription'];
    }
  }
}
